import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { MapPin, Calendar, Clock, Phone, Trash2, X } from "lucide-react"
import PropTypes from "prop-types"

function getStatusBadge(status) {
  const badges = {
    0: "bg-yellow-100 text-yellow-800",
    1: "bg-green-100 text-green-800",
    2: "bg-red-100 text-red-800",
  }
  const labels = {
    0: "Pending",
    1: "Approved",
    2: "Rejected",
  }
  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${badges[status]}`}
    >
      {labels[status]}
    </span>
  )
}

function CabBookingCard({ booking, onDelete, onReject, onClick }) {
  const appointmentDate = new Date(booking.appointment_date)

  return (
    <Card
      className="group hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700 cursor-pointer"
      onClick={() => onClick(booking.id)}
    >
      <CardContent className="p-6">
        <div className="flex justify-between items-start">
          <div className="space-y-1">
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-lg font-semibold tracking-tight hover:text-blue-600 transition-colors">
                {booking.patient_name}
              </h3>
              {getStatusBadge(booking.order_status)}
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <MapPin className="h-4 w-4 mr-2 text-gray-400" />
              <span>{booking.location}</span>
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <Phone className="h-4 w-4 mr-2 text-gray-400" />
              {booking.mobile_number}
            </div>
          </div>

          {booking.order_status === 0 && (
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="icon"
                className="h-8 w-8 border-red-200 hover:border-red-500 hover:bg-red-50"
                onClick={(e) => {
                  e.stopPropagation()
                  onReject(booking)
                }}
              >
                <X className="h-4 w-4 text-red-500" />
              </Button>
              <Button
                variant="outline"
                size="icon"
                className="h-8 w-8 border-gray-200 hover:border-red-500 hover:bg-red-50"
                onClick={(e) => {
                  e.stopPropagation()
                  onDelete(booking)
                }}
              >
                <Trash2 className="h-4 w-4 text-red-500" />
              </Button>
            </div>
          )}
        </div>

        <div className="mt-4 space-y-2">
          <p className="text-sm text-gray-600">{booking.reason}</p>

          <div className="flex items-center justify-between text-sm text-gray-500 mt-4">
            <div className="flex items-center">
              <Calendar className="h-4 w-4 mr-1" />
              {appointmentDate.toLocaleDateString()}
            </div>
            <div className="flex items-center">
              <Clock className="h-4 w-4 mr-1" />
              {appointmentDate.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

CabBookingCard.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.number.isRequired,
    patient_name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    reason: PropTypes.string.isRequired,
    mobile_number: PropTypes.string.isRequired,
    appointment_date: PropTypes.string.isRequired,
    order_status: PropTypes.number.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default CabBookingCard
